module.exports = __webpack_public_path__ + "static/img/5c352a975281099bef4f2712033f2a9c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/index_adv5.jpg
// module id = dY6B
// module chunks = 1